import { CurrencyCodeEnum, LocaleEnum } from "@vini-wine/core-enums";

export const priceFormatter = (
  price: {
    priceMicros: number;
    currencyCode: CurrencyCodeEnum;
    locale?: LocaleEnum;
  },
  showDecimals: boolean,
  roundPrice: boolean,
) => {
  // Extracting data from the price object
  const { priceMicros, currencyCode, locale } = price;

  let priceFloat = priceMicrosToFloat(priceMicros, roundPrice);

  // Formatting price based on locale, currency, and amount
  let formattedPrice = new Intl.NumberFormat(locale ?? "nl", {
    style: "currency",
    currency: currencyCode,
  }).format(priceFloat);

  if (!showDecimals) {
    formattedPrice = formattedPrice.replace(/[.,]00$/, "");
  }
  return formattedPrice;
};

export const priceMicrosToFloat = (price: number, roundPrice: boolean) => {
  if (roundPrice === true) {
    return Math.round(price / 1000000);
  }
  return price / 1000000;
};
